<template>
  <div class="renewal-bill">
    <h1>续费账单</h1>
    <el-table
      :data="data"
      stripe
      style="width: 100%"
      size="medium"
      header-row-class-name="common-table-header"
      row-class-name="common-table-row"
      class="is-print-hide common-table"
      :border="false"
    >
      <el-table-column prop="payNo" label="支付流水号" width="180">
        <template #default="{row:{payNo}}">
          <el-tooltip class="item" effect="dark" :open-delay="500" :content="payNo" placement="top">
            <span class="store-name">
              {{ payNo }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="payTime" label="支付时间">
        <template #default="{row:{payTime}}">
          <el-tooltip class="item" effect="dark" :open-delay="500" :content="payTime" placement="top">
            <span class="store-name">
              {{ payTime }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="payWayDesc" label="支付方式"></el-table-column>
      <el-table-column prop="payStatusDesc" label="支付状态"></el-table-column>
      <el-table-column prop="payPrice" label="支付金额">
        <template #default="{row:{payPrice}}">
          <span>{{ payPrice / 100 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="payRemark" label="备注">
        <template #default="{row:{payRemark}}">
          <el-tooltip class="item" effect="dark" :open-delay="500" :content="payRemark" placement="top">
            <span class="store-name">
              {{ payRemark }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'renewalBill',
  props: {
    payInfoDetail: {
      type: Object
    }
  },
  computed: {
    data() {
      return this.payInfoDetail ? [this.payInfoDetail] : [];
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  padding: 12px 0 10px 0;
}
.renewal-bill {
  margin-bottom: 24px;
}
</style>
